<template>
  <div>

    <el-row style="margin-bottom:10px;">
      <el-col :span="14" class='flex'>
        <el-select v-if="theUserProject == 0" v-model='theProjectId' @change="theProjectAllChange" size="small" clearable
          placeholder="请选择项目">
          <el-option v-for="item in getProjectList_data.data || []" :key="item.projectId" :label="item.projectName"
            :value="item.projectId">
          </el-option>
        </el-select>
        <!-- <el-select v-model='ouStatus' @change="statusChange" size="small">
            <el-option
                v-for="item in ouStatusAll||[]"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
        </el-select> -->
        <el-input v-model="getOppNicheList_data.customName" placeholder="请输入客户名称" clearable size='small'
          style="max-width:200px;" />
        <el-input v-model="getOppNicheList_data.userName" placeholder="请输入用户名" clearable size='small'
          style="max-width:200px;" />
        <el-input v-model="getOppNicheList_data.ouName" placeholder="请输入商机名" clearable size='small'
          style="max-width:200px;" />
        <el-button v-click.getOppNicheList type="primary" icon='el-icon-search' size='small'
          style='margin-left:10px;'>搜索
        </el-button>
        
      
      </el-col>
      <el-col :span="4" class='flex'>
        <el-button @click="Out" type="primary" size='small'  style='margin-left:10px;'>导出 </el-button>
      </el-col>
    </el-row>

    <mytable ref="getOppNicheListTable" :tableColums='tableColums_getOppNicheList' api='getOppNicheList::onId' xupdateapi='updateOppNiche' :height="H - 165">
    </mytable>

    <myform :viewobj='{
      addOuMilestone: ["新增商机信息", "el-icon-circle-plus"],
      updateOppNiche: ["修改商机信息", "el-icon-edit-outline"],
      $succeed$: getOppNicheList
    }' @close='$form("addOuMilestone", "reset")'>
      <template v-slot:customId="{ Myformdata }">
        <el-select v-model="Myformdata.customId" size="small" filterable clearable placeholder="请选择客户">
          <el-option v-for="item in getCustomList_data.data || []" :key="item.customId" :label="item.customName"
            :value="item.customId">
          </el-option>
        </el-select>
      </template>
      <hide slot='onId' />
    </myform>
  </div>
</template>

<script>
import qs from 'qs';
import axios from 'axios';
export default {
  data() {
    return {
      companyFold: false,
      onId: null,
      baseUrl: $Api.baseUrl_online,
      theProjectId: "",
      theUserProject: "",
      theBusinessType: "",
      ouStatus: 1,
      ouStatusAll: [{
        id: 1,
        name: '商机'
      },
      {
        id: 4,
        name: '审核驳回'
      },
      ],
      loading: null,
      tableColums_getOppNicheList: {
        $selection: true,

        // ouNum: '编号',

        onName: '商机名称',
        customName: '客户',
        onMoney: '商机金额',
        dtName: '分公司',
        onDes: '详细描述',

        createusername: '创建人',
        createtime: '创建时间',

        $operation: [
          '操作', 200,
          this.updateOppNiche && `@text: 编辑#success
           @click: $form("updateOppNiche",$row)
          `,
          this.deleteOppNiche && `@text: 删除#danger
           @click: _confirm('确定删除吗?')
                   .trigger('deleteOppNiche',{onId:$row.onId})
                   .trigger('getOppNicheList')
          `,
        ],

      },

    };
  },

  watch: {

  },

  methods: {
    toCheck(){
      this.$confirm('是否确认通过审核, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.auditOpportunityTwoAll().result(res => {
          this.$message({
            type: 'success',
            message: '审核成功'
          })
          this.getData()
        })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    Out() {
        const selection = Object.keys(this.$refs.getOppNicheListTable.$MyTableCache);
        console.log(selection.join());
        var that = this
        const bulkdata = {
          ouStatus: that.ouStatus,
          btId: that.theBusinessType,
          projectId: that.theProjectId,
          customName: that.getOppNicheList_data.customName,
          userName: that.getOppNicheList_data.userName,
          ouName: that.getOppNicheList_data.ouName,
          onIds: selection.join()
        }
        this.openLoading();
        var s = qs.stringify(bulkdata);
      
        axios({
          method: 'post',
          url: that.baseUrl + '/opportunity/opp-niche/exportOppNiche',
          data: s,
          withCredentials: true,
          timeout: 1200000,
          responseType: 'arraybuffer',
          headers: {
            Accept: "application/json",
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            'token': A.local('$Usertoken'),
            'projectId': +A.local('$projectId'),
          }
        }).then(function (res) {
          if (res.data) {
            that.loading.close();
            let a = document.createElement('a');
            //ArrayBuffer 转为 Blob
            let blob = new Blob([res.data], {
              type: "application/vnd.ms-excel"
            });
            let objectUrl = URL.createObjectURL(blob);
            a.setAttribute("href", objectUrl);
            a.setAttribute("download", '商机.xlsx');
            a.click();
            that.$message({
              message: "成功",
              type: "success"
            });
          
          }
        })
    },
    subOustatus(val) {
      this.$confirm('是否确认通过审核, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.auditOpportunityTwo({
          onId: val.onId,
          ouStatusTwo: 2
        }).result(res => {
          this.$message({
            type: 'success',
            message: '审核成功'
          })
          this.getData()
        })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    openLoading() {
      //loading请求等待
      this.loading = this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
    },
    toExport: async function () {
      const that = this;
      var postData = {
        ouStatus: that.ouStatus,
        btId: that.theBusinessType,
        projectId: that.theProjectId,
        customName: that.getOppNicheList_data.customName,
        userName: that.getOppNicheList_data.userName,
        ouName: that.getOppNicheList_data.ouName,
      };
      var s = qs.stringify(postData);
      that.openLoading();
      axios({
        method: 'post',
        url: that.baseUrl + '/opportunity/ou/exportOpportunityListOu',
        data: s,
        withCredentials: true,
        timeout: 1200000,
        responseType: 'arraybuffer',
        headers: {
          Accept: "application/json",
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          'token': A.local('$Usertoken'),
          'projectId': +A.local('$projectId'),
        }
      }).then(function (response) {
        that.loading.close();
        let a = document.createElement('a');
        //ArrayBuffer 转为 Blob
        let blob = new Blob([response.data], {
          type: "application/vnd.ms-excel"
        });
        let objectUrl = URL.createObjectURL(blob);
        a.setAttribute("href", objectUrl);
        a.setAttribute("download", '商机.xlsx');
        a.click();
        that.$message({
          message: "成功",
          type: "success"
        });
      }).catch(function (error) {
        that.loading.close();
        console.log(error);
      });
    },
    theBusinessTypeChange(e) {
      this.theBusinessType = e;
      this.getOppNicheList({
        currentPage: 1,
        projectId: this.theProjectId,
        ouStatus: this.ouStatus,
        btId: this.theBusinessType
      });
    },
    statusChange(e) {
      this.ouStatus = e;
      this.getData();
    },
    theProjectAllChange(e) {
      this.theProjectId = e;
      this.getData();
    },
    getData() {
      this.getOppNicheList({
        projectId: this.theProjectId,
        ouStatus: this.ouStatus,
        btId: this.theBusinessType
      });
    },
  },

  created() {
    this.getCustomList()
    this.theUserProject = A.local('$projectId');
    if (this.theUserProject == 0) {
      this.getProjectList({
        pageSize: 0
      });
    } else {
      this.theProjectId = this.theUserProject;
    }
    this.getData();
  },
  mounted() {

  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/bussiness/IntentionManage.vue